<template>
  <div
    class="my-1.5 inline-flex flex-row flex-wrap items-center space-x-1 px-2"
  >
    <slot />
  </div>
</template>
